'use client';
import Tippy from '@tippyjs/react';

import 'tippy.js/animations/scale.css';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';
//import './tooltip.css';

export const Tooltip = Tippy;
